import { nextOccurrence, type Repeat } from '@werft/domain';
import type { TaskDto } from '@werft/contracts';
import { t, type MessageKey } from '../../i18n/index.js';

/** „wöchentlich“, „alle 2 Wochen“, „monatlich ab Erledigen“ … */
export function repeatText(r: Repeat): string {
  const base = r.interval === 1 ? t(`repeat.every1.${r.unit}` as MessageKey) : t(`repeat.everyN.${r.unit}` as MessageKey, { n: r.interval });
  return r.basis === 'done' ? `${base} ${t('repeat.afterDone')}` : base;
}

/** Wie der Server (ADR 0022): ab Termin im Rhythmus (Verpasstes überspringen) oder ab heute */
export function nextDue(task: TaskDto, today: string): string {
  const r = task.repeat!;
  const from = r.basis === 'due' && task.dueDate ? task.dueDate : today;
  let due = nextOccurrence(from, r);
  for (let i = 0; due < today && i < 1000; i++) due = nextOccurrence(due, r);
  return due;
}
